/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Extended_Access_IncludedInputs */

const fr_admin_subscription_rights_extended_access_included = /** @type {(inputs: Admin_Subscription_Rights_Extended_Access_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclus dans ce palier`)
};

/**

* @param {Admin_Subscription_Rights_Extended_Access_IncludedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_extended_access_included = /** @type {((inputs?: Admin_Subscription_Rights_Extended_Access_IncludedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Extended_Access_IncludedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_extended_access_included(inputs)
});